import { css } from "@emotion/css";
import { $, type Properties, resolve } from "signlets";

import { classes } from "./classes";

const style = css`
  appearance: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: #fff2;
  color: inherit;
  font-family: inherit;
  font-size: inherit;
  text-align: left;
  border: 0.125rem solid transparent;
  border-radius: 0.25rem;
  transition:
    border-color 200ms,
    background-color 200ms,
    color 200ms;

  &.icon {
    padding: 0.5rem;
    font-size: 0;
  }

  &.primary {
    background: #cad5ed;
    color: black;

    &:focus,
    &:hover:not([disabled]) {
      background-color: #fff2;
      color: inherit;
    }
  }

  &:focus,
  &:hover:not([disabled]) {
    border-color: white;
    cursor: pointer;
  }

  &[disabled] {
    background: transparent;
    border-color: #fff2;
    color: #fff2;
  }

  > svg {
    width: 1.25rem;
    height: 1.25rem;
  }
`;

export type ButtonProps = {
  icon?: boolean;
  primary?: boolean;
  disabled?: boolean;
  class?: string;
  title?: string;
  children?: JSX.Element;
  onClick: (event: MouseEvent) => void;
};

export const Button = ({
  icon,
  primary,
  disabled,
  class: _class,
  title,
  onClick,
  children,
}: Properties<ButtonProps>) => (
  <button
    disabled={disabled}
    class={$(() =>
      classes(
        style,
        resolve(icon) && "icon",
        resolve(primary) && "primary",
        resolve(_class),
      ),
    )}
    title={title}
    onClick={onClick}
  >
    {children}
  </button>
);
